import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { BusinessComponent } from './pages/business/business.component';
import { CareersComponent } from './pages/careers/careers.component';
import { ContactComponent } from './pages/contact/contact.component';
import { BuCompanyComponent } from './pages/bu-company/bu-company.component';
import { ChemicalMineralFiberComponent } from './pages/chemical-mineral-fiber/chemical-mineral-fiber.component';
import { InsulationComponent } from './pages/insulation/insulation.component';
import { LogisticComponent } from './pages/logistic/logistic.component';
import { OilGasComponent } from './pages/oil-gas/oil-gas.component';
import { HandlingComponent } from './pages/handling/handling.component';
import { SpecialComponent } from './pages/special/special.component';
import { ProcessingDataComponent } from './pages/processing-data/processing-data.component';


const routes: Routes = [
{
  path: ':l/home',
  component: HomeComponent
},
{
  path: ':l/bu-company',
  component: BuCompanyComponent
},
{
  path: ':l/business',
  component: BusinessComponent
},
{
  path: ':l/careers',
  component:CareersComponent
},
{
  path: ':l/contact',
  component:ContactComponent
},
{
  path: ':l/chemical',
  component:ChemicalMineralFiberComponent
},
{
  path: ':l/insulation',
  component:InsulationComponent
},
{
  path: ':l/logistic',
  component:LogisticComponent
},
{
  path: ':l/oil',
  component:OilGasComponent
},
{
  path: ':l/handling',
  component:HandlingComponent
},
{
  path: ':l/special',
  component:SpecialComponent
},
{
  path: ':l/processing-data',
  component:ProcessingDataComponent
},
{
  path: '',
  redirectTo:'home',
  pathMatch: 'full'
}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'disabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
